import { render, staticRenderFns } from "./AdministrativeManagementAdd.vue?vue&type=template&id=9dddd37c&scoped=true&"
import script from "./AdministrativeManagementAdd.vue?vue&type=script&lang=js&"
export * from "./AdministrativeManagementAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dddd37c",
  null
  
)

export default component.exports